export const SET_DATE_CHANGE = "SET_DATE_CHANGE";
export const SET_DATE = "SET_DATE";
export const DATE_RESET_REDUX = "DATE_RESET_REDUX";

export const setDate = (date) => ({
  type: SET_DATE,
  date,
});